module.exports = __webpack_public_path__ + "static/media/ken-classroom.816c4d05.jpg";